import {useEffect, useRef, useState} from "react"
import {Link, useLocation} from "react-router-dom"
import {HashLink} from "react-router-hash-link"
import {pagePaths} from "../Seo/Seo"
import "./Header.scss"

export default function Header() {
    const [showMobileLinks, setShowMobileLinks] = useState(false)
    const header = useRef(null)
    const toggle = useRef(null)
    const location = useLocation()
    const currentPage = location.pathname === "/" ? "/" : location.pathname.replace(/\/+$/, "") + "/"
    const calculatorPage = pagePaths.includes(currentPage) && currentPage !== "/policy/" ? currentPage : "/"

    // Site navigation is a disclosure, not an application menu or a modal.
    // No background scroll lock or focus trap is needed for this dropdown.
    useEffect(() => { setShowMobileLinks(false) }, [location.pathname, location.hash])
    useEffect(() => {
        if (!showMobileLinks) return
        const escape = event => {
            if (event.key === "Escape") {
                event.preventDefault()
                setShowMobileLinks(false)
                toggle.current?.focus()
            }
        }
        const outside = event => {
            if (!header.current?.contains(event.target)) setShowMobileLinks(false)
        }
        const desktop = window.matchMedia("(min-width: 849px)")
        const resize = event => { if (event.matches) setShowMobileLinks(false) }
        document.addEventListener("keydown", escape)
        document.addEventListener("pointerdown", outside)
        desktop.addEventListener("change", resize)
        return () => {
            document.removeEventListener("keydown", escape)
            document.removeEventListener("pointerdown", outside)
            desktop.removeEventListener("change", resize)
        }
    }, [showMobileLinks])

    return (
        <nav ref={header} className="Header navbar navbar-default" aria-label="Основная навигация"
            onBlur={event => {
                if (event.relatedTarget && !event.currentTarget.contains(event.relatedTarget)) setShowMobileLinks(false)
            }}>
            <Link to="/" className="navbar__brand" aria-label="Флика — главная">
                <img height="50px" src="/logo/fleeka-logo-new.png" alt="Флика" />
            </Link>
            <div className="navbar__links">
                <HashLink smooth to="/#help" className="navbar__link"><span>Помощь</span></HashLink>
                <Link to="/policy/" className="navbar__link"><span>Пользовательское соглашение</span></Link>
            </div>
            <button ref={toggle} type="button" className="navbar__mobile-burger"
                aria-label={showMobileLinks ? "Закрыть меню" : "Открыть меню"}
                aria-expanded={showMobileLinks} aria-controls="fleeka-mobile-navigation"
                onClick={() => setShowMobileLinks(open => !open)}>
                <svg aria-hidden="true" focusable="false" viewBox="0 0 50 50" width="50" height="50">
                    <path d={showMobileLinks
                        ? "M 7.7070312 6.2929688 L 6.2929688 7.7070312 L 23.585938 25 L 6.2929688 42.292969 L 7.7070312 43.707031 L 25 26.414062 L 42.292969 43.707031 L 43.707031 42.292969 L 26.414062 25 L 43.707031 7.7070312 L 42.292969 6.2929688 L 25 23.585938 L 7.7070312 6.2929688 z"
                        : "M 5 9 L 5 11 L 45 11 L 45 9 L 5 9 z M 5 24 L 5 26 L 45 26 L 45 24 L 5 24 z M 5 39 L 5 41 L 45 41 L 45 39 L 5 39 z"} />
                </svg>
            </button>
            <div id="fleeka-mobile-navigation" className="navbar__mobile-links" hidden={!showMobileLinks}>
                <div className="links">
                    <Link to="/" className="navbar__link" onClick={() => setShowMobileLinks(false)}>Главная</Link>
                    <HashLink smooth to={calculatorPage + "#qq-trip-calculator"} className="navbar__link navbar__link--calculator"
                        onClick={() => setShowMobileLinks(false)}>Рассчитать стоимость</HashLink>
                    <HashLink smooth to="/#help" className="navbar__link" onClick={() => setShowMobileLinks(false)}>Помощь</HashLink>
                    <Link to="/policy/" className="navbar__link" onClick={() => setShowMobileLinks(false)}>Пользовательское соглашение</Link>
                </div>
            </div>
        </nav>
    )
}
